import React, { useEffect, useState } from "react";
import { ClickAwayListener } from "@material-ui/core";
import calendericon from "../../../assets/calender_icon.svg";
import { Calendar } from "react-date-range";
import moment from "moment";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./DatePicker.scss";

const DatePicker = (props) => {
  const { handleDateChange, selectorDate, message } = props;
  const [display, setDisplay] = useState(false);
  const [newDate, setNewDate] = useState(new Date());

  useEffect(() => {
    if (selectorDate) {
      const datePart = selectorDate.split("/");
    } else {
      setNewDate("");
    }
  }, [selectorDate]);

  const handleDatePicker = (value) => {
    setNewDate(value);
    handleDateChange(value);
    setDisplay(false);
  };
  return (
    <>
      <div id="dob">
        <div className="dob_div">
          <div className="dob-input-holder">
            <input
              value={newDate !== "" ? moment(newDate).format("YYYY-MM-DD") : ""}
              autoComplete="off"
              onClick={() => setDisplay(!display)}
            />
            {newDate !== "" ? (
              <span
                className="clear_icon"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setNewDate("");
                  handleDateChange("");
                }}
              >
                <i class="fa fa-times-circle" aria-hidden="true"></i>
              </span>
            ) : null}
            <img
              className="cal_img"
              src={calendericon}
              alt="calender"
              style={{ cursor: "pointer" }}
              onClick={() => setDisplay(!display)}
            />
          </div>
        </div>
        {message && <span className="mt-1 note">{message}</span>}
        {display ? (
          <div className="cal_modal">
            <ClickAwayListener
              onClickAway={() => {
                setDisplay(false);
              }}
            >
              <Calendar
                onChange={(date) => {
                  handleDatePicker(date);
                }}
                date={newDate}
                maxDate={new Date()}
                color="#F969A4"
                editableDateInputs={true}
              />
            </ClickAwayListener>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default DatePicker;
